module.exports = __webpack_public_path__ + "static/media/supervised-user-circle.952c0f52.svg";